export default __webpack_public_path__ + "static/media/google-play.5ea8c755.png";